import {Device, colors, fonts} from '../../constants';
import React from 'react';
import styled from 'styled-components';

interface Props {
  className: string;
  children: React.ReactNode;
}

export const RedeemViewStyled = styled.div`
  padding: 10px 0;
  min-height: 100vh;
  h1.site-block-page-title {
    margin-top: 0;
    padding: 2em 0;
    text-transform: uppercase;
    color: $white;
    text-align: center;
    @media screen and ${Device.tablet} {
      padding: 1em 0;
      font-size: 2em;
    }
  }
  .redeemLoading {
    @media screen and ${Device.tablet} {
      min-height: 100vh;
    }
  }
  @media screen and ${Device.tablet} {
    min-height: initial;
    padding: 0 0 50px;
  }
  @media screen and ${Device.mobileL} {
    padding: 0 0 24px;
  }

  .posa-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 50%;
    max-width: 50em;
    background: linear-gradient(to right, #0e0e0e 0%, #3d3d3d 100%);
    padding: 2% 3%;
    margin: 2em 0;
    @media screen and ${Device.tablet} {
      width: 75%;
    }
    @media screen and ${Device.mobileL} {
      width: 100%;
      flex-wrap: wrap;
      padding: 0.5em 2em;
    }
    .posa-content-block {
      width: 50%;
      padding: 0;
      color: white;
      @media screen and ${Device.mobileL} {
        width: 100%;
        text-align: center;
      }
    }
    a {
      text-decoration: underline;
    }
    img {
      width: 100%;
      margin-left: 4em;
      @media screen and ${Device.mobileL} {
        width: 60%;
        margin-left: 0;
        margin-top: 1em;
      }
    }
    .ar {
      .redeemView,
      .inviteView {
        direction: rtl;
        .site-block {
          text-align: initial;
        }
      }
    }
  }
  .posa-callout-container {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    align-items: stretch;
    padding-right: 10%;
    gap: 1em;

    @media screen and ${Device.tablet} {
      flex-direction: column;
      padding-right: 0;
    }

    .card-callout-box {
      flex: 1;
      display: flex;
      flex-direction: column;

      &.giftcard {
        justify-content: center;
      }
    }

    &:has(> .card-callout-box:only-child) {
      .card-callout-box {
        flex: 0 0 60%;
        max-width: 900px;

        @media screen and ${Device.laptopM} {
          flex: none;
          width: 100%;
        }
      }
    }
  }
  .redeemContainer {
    .site-block {
      a {
        color: ${colors.yellow};
        font-family: ${fonts.primary};
        text-decoration: underline;
      }
    }
  }
`;

const RedeemViewStyledExtended = ({className = '', children, ...rest}: Props) => (
  <RedeemViewStyled className={className} {...rest}>
    {children}
  </RedeemViewStyled>
);

export default RedeemViewStyledExtended;
